import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { FulfillmentEventT } from "../../types/Fulfillment";

interface ScheduleSummaryEventProps {
  event: FulfillmentEventT;
}

const color = "#0D47A1";
const fontSize = 13;

const FullLabels = {
  count_deliveries: "Deliveries",
  count_customers: "Customers",
  count_volume_upgrades: "Volume Upgrades",
};

const NarrowLabels = {
  count_deliveries: "Del",
  count_customers: "Cx",
  count_volume_upgrades: "VU",
};

const boxSx = {
  display: "flex",
  fontSize,
  justifyContent: "space-between",
  width: "100%",
};

const countSx = {
  color,
  fontSize,
  fontWeight: "bold",
  textAlign: "right",
};

const labelSx = {
  color,
  fontSize,
};

const ScheduleSummaryEvent: React.FC<ScheduleSummaryEventProps> = ({
  event,
}) => {
  const theme = useTheme();
  const isNarrow = useMediaQuery(theme.breakpoints.down("xl"));

  const formatValue = (value: React.ReactNode | Date | number | string) => {
    if (value instanceof Date) {
      return value.toLocaleString();
    }
    if (value === null || value === undefined) {
      return "N/A";
    }
    return value;
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        whiteSpace: "normal",
        backgroundColor: "rgba(33, 150, 243, 0.2)",
        border: "1px solid rgba(33, 150, 243, 0.75)",
        borderRadius: "4px",
        height: "100%",
        overflow: "auto",
        padding: 1,
        boxSizing: "border-box",
      }}
    >
      {Object.entries(isNarrow ? NarrowLabels : FullLabels).map(
        ([key, label]) => (
          <Box key={key} sx={boxSx}>
            <Typography variant="body2" sx={labelSx}>
              {label}
            </Typography>
            <Typography variant="body2" sx={countSx}>
              {formatValue(event[key as keyof FulfillmentEventT])}
            </Typography>
          </Box>
        )
      )}
    </Box>
  );
};

export default ScheduleSummaryEvent;
